import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';
import { ModulesStore } from '../../../features/admin/modules/modules.store';
import { UserStore } from '../../services/user.store';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
  const router: Router = inject(Router);
  const authService = inject(AuthService);
  const modulesStore = inject(ModulesStore);
  const userStore = inject(UserStore);

  const urlSegments = state.url.split('/');
  const moduleSlug = urlSegments[1] || ''; // First segment after the leading slash
  const module = modulesStore.getModuleBySlug(moduleSlug);

  if (module?.isPublic) {
    // If the module is public, allow access
    return of(true);
  }
  // Check the authentication status
  return authService.check().pipe(
    switchMap(authenticated => {
      // If the user is not authenticated...
      if (!authenticated) {
        // Save the current URL to redirect back after login
        const returnUrl = state.url;
        sessionStorage.setItem('redirectUrl', returnUrl);

        // Redirect to the sign-in page
        const urlTree = router.parseUrl('/home');

        return of(urlTree);
      }

      if (userStore.isOnboarding() && moduleSlug != 'onboarding') {
        const urlTree = router.parseUrl('/onboarding');
        return of(urlTree);
      }

      // Allow the access
      return of(true);
    })
  );
};
